import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { ListPanel } from "../FGs_ListPanel/ListPanel";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: true,
    Icon: null,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ListPanel: ListPanel,
    createConfig:  {
        group: 'FunctionGroups',
        name: "Air handling units - humidity controller",
        description: "AHU humidity controller",
        panel: OverviewPanel,
        defaultState: { },
    },
}
